import { useCallback } from 'react';

import useRefreshUser from './useRefreshUser';

// The recipient's onboarding status changes server-side, so reload the user as soon as one arrives.
const ONBOARDING_DECISION_EVENT_TYPES = new Set([
  'auth.onboarding_request.approved',
  'auth.onboarding_request.rejected',
]);

const useNotificationEvents = (): ((notification: { eventType: string }) => void) => {
  const refreshUser = useRefreshUser();

  return useCallback(
    ({ eventType }: { eventType: string }): void => {
      if (ONBOARDING_DECISION_EVENT_TYPES.has(eventType)) {
        void refreshUser();
      }
    },
    [refreshUser]
  );
};

export default useNotificationEvents;
